<template>
  <header class="header">
    <app-modal></app-modal>
    <app-advertising-filter v-if="visualizarCampanha"
                            data-entity="promocionalcode" />

    <app-date-range-filter data-entity="promocionalcode" />

    <LocalEstableshimentFilter data-entity="promocionalcode" />

    <div class="search-wrapper">
      <app-search @submit="search" />
    </div>
  </header>
</template>

<script>
    import LocalEstableshimentFilter from '@components/filters/LocalEstableshimentFilter'
    import EventBus from '@packages/event-bus'
    import AppModal from './promocionalcode-modal/PromocionalCodeModal'
    import AppAdvertisingFilter from '@components/filters/AdvertisingFilter'
    import AppDateRangeFilter from '@components/filters/DateRangeFilter'
    import AppSearch from '@components/Search'

    export default {
        components: {
            AppModal,
            AppAdvertisingFilter,
            AppDateRangeFilter,
            AppSearch,
            LocalEstableshimentFilter
        },

        computed: {
            filters() {
                return this.$store.state.promocionalcode.filters
            },

            permissions() {
                return this.$store.state.users.user.permissions;
            },

            visualizarCampanha() {
              return this.permissions['VISUALIZAR_CAMPANHA']
            },
            
            isAnunciante() {
                return this.$store.state.users.user.tipo === 'ANUNCIANTE';
            },

            hasEstableshimentFilter() {
              return !!this.filters.establishments.length
            },

            isEstabelecimento() {
              return this.$store.state.users.user.tipo === 'ESTABELECIMENTO';
            },

            isAdmin() {
              return this.$store.state.users.admin && !this.$store.state.users.user
            },
        },

        mounted(){
            this.$store.commit('PROMOCIONALCODE_RESET_FILTERS')
        },
        methods: {
            search(search) {
                EventBus.$emit('GO_TO_FIRST_PAGE')
                this.$store.commit('PROMOCIONALCODE_SET_FILTER', {key: 'search', value: search})
            }
        },

    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .filters {
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding: 0 2% 0 12%;
    flex-grow: 1;

    .search-wrapper {
      max-width: 200px;
    }
  }

  .mdi {
    font-size: 28px;
    color: $grey-6;
    cursor: pointer;

    &.active {
      color: $blue-primary;
    }

    &.mdi-view-grid {
      font-size: 22px;
    }
  }
}
</style>
